import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Download = ({
  size,
  type,
  theme,
  className,
  dataTestId = "download-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00125 1.12305C8.36944 1.12305 8.66792 1.42152 8.66792 1.78971V8.9517L11.2755 6.32164C11.5347 6.06018 11.9568 6.05836 12.2183 6.31759C12.4797 6.57682 12.4815 6.99892 12.2223 7.26039L8.47479 11.0403C8.34961 11.1665 8.17917 11.2376 8.00137 11.2376C7.82356 11.2376 7.65313 11.1665 7.52794 11.0403L3.78043 7.26039C3.5212 6.99892 3.52301 6.57682 3.78448 6.31759C4.04595 6.05836 4.46805 6.06018 4.72728 6.32164L7.33458 8.95146V1.78971C7.33458 1.42152 7.63306 1.12305 8.00125 1.12305ZM13.1171 13.5423L2.88424 13.5423L2.88424 12.0465C2.88424 11.6783 2.58576 11.3798 2.21757 11.3798C1.84938 11.3798 1.5509 11.6783 1.5509 12.0465V13.5423C1.5509 14.2787 2.14786 14.8757 2.88424 14.8757L13.1171 14.8757C13.8535 14.8757 14.4505 14.2787 14.4505 13.5423V12.0465C14.4505 11.6783 14.152 11.3798 13.7838 11.3798C13.4156 11.3798 13.1171 11.6783 13.1171 12.0465V13.5423Z"
    />
  </SVGIcon>
);
